import { render, staticRenderFns } from "./fileUplode.vue?vue&type=template&id=6c608287&scoped=true"
import script from "./fileUplode.vue?vue&type=script&lang=js"
export * from "./fileUplode.vue?vue&type=script&lang=js"
import style0 from "./fileUplode.vue?vue&type=style&index=0&id=6c608287&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c608287",
  null
  
)

export default component.exports